export enum QBankStructureLevelItemFormAction {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
}

export const QBANK_STRUCTURE_LEVEL_ITEM_FORM_ACTION_QUERY_KEY = 'action';
